import React, { useEffect, useState } from 'react';
import { useListadoRecordado } from '../../components/useListadoRecordado';
import axios from '../../axiosConfig';
import Table from 'react-bootstrap/Table';
import { Modal } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { useLoading } from '../../components/LoadingContext'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationTable from '../../components/PaginationTable'; 
import { ResponsiveContainer,Line, LineChart,BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,AreaChart,Area,Radar,RadarChart, PieChart, Cell, Pie, ComposedChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { FaSync,FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons
import { FaLocationDot } from "react-icons/fa6";


const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00C49F', '#FFBB28'];




const ShowCentros = () => {
    const [Centros, setCentros] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [filteredReportes, setFilteredReportes] = useState([]);
    const [searchName, setsearchName] = useState('');
    const [error, setError] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const { setLoading } = useLoading();
    const userRole = localStorage.getItem('role'); // Obtener el rol del usuario desde el localStorage
    const itemsPerPage = 4; // Número de elementos por página
    const [avgMontoCancelado, setAvgMontoCancelado] = useState(0);
    const [latestTasa, setLatestTasa] = useState({ tasa: 0, created_at: '' });
    const [loadingData, setLoadingData] = useState(false); // Estado para controlar la recarga
    const [range, setRange] = useState(30); // Estado para seleccionar el rango de días
    const [statistics, setStatistics] = useState({});
    const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially


    // Página y filtros se recuerdan: al volver de Editar el listado queda donde estaba.
    const { filters, setFilters, currentPage, setCurrentPage } = useListadoRecordado('centros', {
        descripcion: '', 
        cod:'',   
        direccion:'',
        confirmar:true, 
        externo:'',    
        status:'',

    });
    const isActiveFilterValue = (v) => {
  if (v === null || v === undefined) return false;
  return String(v).trim() !== "";
};

 const activeFilterClass = (v) => (isActiveFilterValue(v) ? "is-active-filter" : "");
    
    const handleShowModal = (id) => {
        setSelectedId(id);  // Almacena el ID del participante que se va a eliminar
        setShowModal(true); // Muestra el modal
    };
    
    const handleCloseModal = () => {
        setShowModal(false); // Cierra el modal
    };   

    useEffect(() => {
        setLoading(true);
        getAllCentros(currentPage).finally(() => {
            setLoading(false);
        });
    }, []);


    const getAllCentros = async (page = 1) => {
        // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
        // un número es la página 1. Y la página mostrada se fija aquí, así
        // coincide siempre con los datos (buscar, recargar, borrar, paginar).
        const pagina = Number.isInteger(page) && page > 0 ? page : 1;
        setCurrentPage(pagina);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/centro-estadisticas`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina },
            });
            
            const estadisticas = response.data.estadisticas || {};
            
            setCentros(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setStatistics(estadisticas);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setCentros([]);
            setStatistics({});
        }
    };
    
    const deleteCentros = async () => {
            try {
                const token = localStorage.getItem('token');
                await axios.delete(`/centro/${selectedId}`,{
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                getAllCentros();
                setShowModal(false); // Cierra el modal tras la eliminación exitosa
                toast.success('Centro eliminado con éxito');
            } catch (error) {
                setError('Error deleting data');
                console.error('Error deleting data:', error);
                toast.error('Error al eliminar el Centro');
            }
        
    };
 
  
    const loadData = async () => {
        setLoadingData(true); // Inicia el estado de carga
        try {
            await (getAllCentros()); // Espera a que getAllDatos haga la solicitud y actualice los datos
        } catch (error) {
            console.error('Error recargando los datos:', error); // Maneja el error si ocurre
        } finally {
            setLoadingData(false); // Detener el estado de carga cuando la solicitud haya terminado
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };
 
    const handlePageChange = (page) => {
        setCurrentPage(page);
        getAllCentros(page); // Llama a `getAllDatos` con el nuevo número de página
        
    };

    const totalCentros = statistics.totalCentros || 0;


    const columns = ["id", "COD","Centro","Dirección", "Tlf","Acciones"];

    const renderItem = (Centros) => (
        <tr key={Centros.id}>
            <td >{Centros.id}</td>
        <td >{Centros.cod}</td>
        <td >{Centros.descripcion}</td>
        <td >{Centros.direccion}</td>
        <td >{Centros.tlf}</td>
       
        <td >
            <div className="d-flex justify-content-around">
                {userRole === 'admin'  || userRole === 'coordinador' ? (

                <Button
                    variant="btn btn-warning" 
                    onClick={() => navigate(`/centros/edit/${Centros.id}`)}
                    className="me-2"
                    title='Editar'
                >
                    <i className="bi bi-pencil-fill"></i>
                </Button>
                 ) :null}

                {userRole === 'admin' && (
                <Button
                variant="btn btn-danger"
                onClick={() => handleShowModal(Centros.id)}
                className="me-2"
                title='Eliminar'
                >
                <i className="bi bi-trash3-fill"></i>
                </Button>
                )}
            </div>
        </td>
        </tr>
    );

    return (
        <div className="container-fluid mt-2" style={{ fontSize: '0.85rem' }}>
            <div className="col-lg-11 mx-auto d-flex justify-content-center"> 
                <div className="stat-box d-flex justify-content-center align-items-center" style={{ maxWidth: '100%' }}>
                    {/* Total de Centros */}
                    <div className="stat-card text-center" style={{ padding: '5px', width: '100%' }}>
                        <div className="stat-icon"><FaLocationDot /></div>
                        <div className="stat-number" style={{ color: '#58c765', fontSize: '1.2rem' }}>{totalCentros}</div>
                        <div className="stat-label">Total de Centros</div>
                    </div>
                </div>
            </div>




            <div className="row" style={{ marginTop: '10px' }}>
                {/* Columna para la tabla */}
                <div className="col-lg-11 mx-auto"> {/* Agregamos 'mx-auto' para centrar */}
                    <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}> 
                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: '0px' }}>
                        <h2>Lista de Centros</h2>
                        <div className="d-flex align-items-center">
                             <Form.Select
                                name="externo"
                                value={filters.externo}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.externo)}
                                style={{ width: 'auto' }}
                                >
                                <option value="">Tipo</option>
                                <option value="true"> Externos</option>
                                <option value="false"> Propios</option>
                            </Form.Select>
                            <Form.Select
                                name="status"
                                value={filters.status}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.status)}
                                style={{ width: 'auto' }}
                                >
                                <option value="">Status</option>
                                <option value="true"> Centros Activos</option>
                                <option value="false"> Centros Inactivos</option>
                            </Form.Select> 
                            <Form.Control
                                name='descripcion'
                                type="text"
                                placeholder="Buscar por Nombre"
                                value={filters.descripcion}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.descripcion)}
                            />
                            <Form.Control
                                name='cod'
                                type="text"
                                placeholder="Buscar por Cod"
                                value={filters.cod}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.cod)}
                            />
                           
                            <Button
                                variant="info me-2"
                                onClick={loadData}
                                disabled={loadingData} // Deshabilita el botón si está cargando
                                style={{ padding: '5px 10px', width: '90px' }} // Ajusta padding y ancho
                                title='Recargar datos'

                                >
                                {/* Icono de recarga */}
                                {loadingData ? (
                                    <FaSync className="spin" /> // Ícono girando si está cargando
                                ) : (
                                    <FaSync />
                                )}
                            </Button>
                            <Button 
                                    variant="info me-2" 
                                    onClick={getAllCentros}
                                    style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                                    title='Buscar'
                                >
                                    <FaSearch className="me-1" /> {/* Ícono de lupa */}
                                </Button>
                            {userRole === 'admin' ||userRole === 'coordinador' ? (

                            <Button variant="btn custom" onClick={() => navigate('/centros/create')} className="btn-custom" title='Crear Centro'>
                            <i className="bi bi-geo-fill me-2  "></i> Nuevo
                            </Button>
                            ):null}
                        </div>
                    </div>
                    {/* Tabla paginada */}
                    
                        <PaginationTable
                            data={Centros}
                            itemsPerPage={itemsPerPage}
                            columns={columns}
                            renderItem={renderItem}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            totalPages={totalPages}  
                        />


                    {/* Modal  de eliminación */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar eliminación</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>¿Estás seguro de que deseas eliminar este Centro?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Cancelar
                    </Button>
                    <Button variant="danger" onClick={deleteCentros}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer />
        </div>
        
        </div>
        </div>
        </div>
    );
};

export default ShowCentros;
